import BuilderMaskGroupWflBehaviour from '@form-engine/builder-mask/components/groups/wfl-behaviour';
import BuilderMaskGroup from '@form-engine/builder-mask/components/mask/group';
import BuilderEnumProperty from '@form-engine/builder-mask/components/properties/enum';
import { useMaskProperty } from '@form-engine/builder-mask/hooks/use-mask';
import BuilderFieldNameProperty from '@form-engine/builder-mask/components/properties/field-name';
import { i18n } from '@form-engine/builder-application/index';
import { apiName } from '../workflow-layers/signal';
export function BuilderShowPageWflSetup() {
    const [signalType] = useMaskProperty('signalType');
    const { c } = i18n.prefix(`mask.${apiName}.`);

    return (
        <>
            <BuilderMaskGroupWflBehaviour />
            <BuilderMaskGroup label={c('groupTitle')}>
                <BuilderEnumProperty
                    propertyName="signalType"
                    label={c('signalType')}
                    defaultValue="default"
                    options={[
                        ['default', c('options.default')],
                        ['onFieldChange', c('options.onFieldChange')],
                    ]}
                />
                {signalType === 'onFieldChange' && (
                    <BuilderFieldNameProperty
                        propertyName="signalOnChangeSource"
                        label={c('signalOnChangeSource')}
                    />
                )}
            </BuilderMaskGroup>
        </>
    );
}

export default function BuilderShowPageWflMask() {
    return <BuilderShowPageWflSetup />;
}
